import React from "react";
import * as THREE from "three";

const MastColumnNone = ({ column, colorList, luminaires, gridScaleX, gridScaleY }) => {
    const { height = 6, tilt, point, positionAngle } = column.values;
    const { x, y } = point;
    const radius = 0.2;
    const defaultBaseColor = "orange";
    const safeScaleX = gridScaleX || 1;
    const safeScaleY = gridScaleY || 1;
    const columnBaseZ = -height / 2;
    const renderX = x / safeScaleX;
    const renderY = (y * -1) / safeScaleY;
    const { lanterns = [] } = column.values;
    const outreach = column.values.outreach || 0.75;

    const getOutreachWidth = (lantern) => {
        const useLanternOutreach = column.values.useLanternOutreach;
        const value = useLanternOutreach && lantern?.outreach != null
            ? lantern.outreach
            : outreach;
        return 0.75 * value;
    };
    const normalize360 = (angle) => ((Number(angle) % 360) + 360) % 360;

    return (
        <>
            <mesh
                position={[renderX, renderY, columnBaseZ]}
                rotation={[Math.PI / 2, 0, 0]}
            >
                <cylinderGeometry
                    args={[radius, radius, height, 32]}
                />
                <meshStandardMaterial color={defaultBaseColor} depthTest depthWrite />
            </mesh>

            {lanterns.map((lantern, index) => {
                const mastAngle = normalize360(positionAngle ?? 0);
                const lanternAngle = normalize360(lantern?.positionAngle ?? 0);
                const angle = normalize360(mastAngle + lanternAngle);
                // Match 2D mast direction convention in XY while accounting for 3D Y inversion.
                const angleRad = (angle + 90) * (Math.PI / 180);
                const tiltDeg = Math.abs(Number(tilt ?? 0)) < 0.001 ? 0 : Number(tilt ?? 0);
                const tiltRad = (tiltDeg * Math.PI) / 180;

                const direction = new THREE.Vector3(Math.cos(angleRad), -Math.sin(angleRad), 0).normalize();

                const topOfColumn = [
                    renderX,
                    renderY,
                    columnBaseZ - height / 2 + 0.05,
                ];

                const luminaireIndex = luminaires.indexOf(lantern.luminaireId);
                const resolvedColor =
                    luminaireIndex !== -1 && colorList[luminaireIndex]
                        ? colorList[luminaireIndex]
                        : defaultBaseColor;

                const width = getOutreachWidth(lantern);
                const insetIntoColumn = 0.05;
                const sinkIntoColumn = 0.14;
                const gapBelowTop = 0.1;
                const headHalfHeight = 0.1;
                // In this scene's local coordinates, increasing Z moves lantern heads down the mast.
                const headCenterZ = topOfColumn[2] + headHalfHeight + sinkIntoColumn + gapBelowTop;
                const innerAnchorX = topOfColumn[0] - (direction.x * insetIntoColumn) / safeScaleX;
                const innerAnchorY = topOfColumn[1] - (direction.y * insetIntoColumn) / safeScaleY;

                return (
                    <group
                        key={index}
                        position={[innerAnchorX, innerAnchorY, headCenterZ]}
                        rotation={[0, 0, -angleRad]}
                    >
                        <mesh
                            position={[width / 2, 0, 0]}
                            rotation={[0, tiltRad, 0]}
                        >
                            <boxGeometry
                                args={[width, 0.2, 0.2]}
                            />
                            <meshStandardMaterial color={resolvedColor === '#FFA500 ' ? defaultBaseColor : resolvedColor} depthTest depthWrite />
                        </mesh>
                    </group>
                );
            })}
        </>
    );
};

export default MastColumnNone;
